import {connect} from 'react-redux';
import AddCommentIcon, {AddCommentIconProps} from './AddCommentIcon';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import {MobileViewingModes} from '../../globals/Constants';

const mapStateToProps = (state: ReduxState, ownProps: AddCommentIconContainerProps): Partial<AddCommentIconProps> => {
   return {
      annotationMode: state.annotationMode,
      mobileViewingMode: state.mobileViewingMode,
      pausePlayer: ownProps.pausePlayer
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<AddCommentIconProps> => {
   return {
      setAnnotationMode: state => {
         dispatch(Action.setAnnotationMode(state));
      },
      setMobileViewingMode: (mobileViewingMode: MobileViewingModes) => {
         dispatch(Action.setMobileViewingMode(mobileViewingMode));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCommentIcon);

export interface AddCommentIconContainerProps {
   pausePlayer(): void;
}